"use client"
import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from "@iconify/react";
import { updateLoginMethod } from './userType.service';
import { resultMessage } from '../../../../service/apiResult';
import {
    confirmationDialogSx,
    confirmationIconSx,
    confirmationPrimaryButtonSx,
    confirmationSecondaryButtonSx,
    confirmationTextSx,
    confirmationTitleSx,
} from '../../../styles/dialogStyles';

/**
 * PIN login: switches a persona between OTP and PIN sign-in. Nobody is signed out; the new method
 * applies from each user's next login, and the backend still falls back to OTP when PIN login is
 * switched off for the environment or the app does not support it.
 */
export default function LoginMethodModal(props) {

    const { onClose, getUserTypeData, selectedId, loginMethod, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose, setActionError } = props;
    const newMethod = loginMethod === 'PIN' ? 'OTP' : 'PIN';

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const res = await updateLoginMethod(selectedId, newMethod);
        setLoading(false);

        if (!res.success) {
            setActionError(resultMessage(res));
            onClose();
            return;
        }

        setActionError('');
        // The endpoint returns the updated persona, not a message, so the wording is ours.
        setResponseMsg(resultMessage(res, `Login method changed to ${newMethod}`));
        setAlert('true');
        setOpenAlert(true);
        setTimeout(() => {
            alertClose();
            getUserTypeData();
            onClose();
        }, ALERT_DURATION);
    };

    const message = newMethod === 'PIN'
        ? 'Users of this type will sign in with a PIN from their next login. Each user sets their PIN once, after a one-time SMS code.'
        : 'Users of this type will sign in with an SMS code again from their next login. Their PINs are kept in case you switch back.';

    return (
        <Box sx={confirmationDialogSx}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button onClick={onClose} sx={{ minWidth: 'auto', p: 0.5, color: '#6B7280', borderRadius: '999px' }}>
                    <CloseIcon data-testid="cancel-icon" />
                </Button>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={confirmationIconSx}>
                        <Icon icon="mingcute:warning-line" width="36" height="36" color="#C40000" />
                    </Box>
                    <Typography sx={confirmationTitleSx}>Switch to {newMethod} login?</Typography>
                    <Typography sx={confirmationTextSx}>{message}</Typography>
                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button variant="contained" type="submit" sx={confirmationPrimaryButtonSx}>Yes</Button>
                        <Button onClick={onClose} sx={confirmationSecondaryButtonSx}>No</Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    )
}
